import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getLocations = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/locations`);
  return data;
});
export const getOverview = catchAsync(async (params) => {
  const { data } = await axiosInstance.get(`salon/overview`, { params });
  return data;
});
export const getTeamMembers = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/team-members`);
  return data;
});
export const getServices = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/services`);
  return data;
});
